import { BehaviorSubject } from 'rxjs';

const userItemKey = 'currentUser';

const currentUserSubject =
  new BehaviorSubject(JSON.parse(localStorage.getItem(userItemKey)));

function login(isAdmin) {
  const user = {
    isAdmin: isAdmin
  };
  localStorage.setItem(userItemKey, JSON.stringify(user));
  currentUserSubject.next(user);
};

export const authenticationService = {
  setAdmin: login,
  user: currentUserSubject.asObservable(),
  get currentUserValue() { return currentUserSubject.value }
};